/* eslint-disable import/prefer-default-export */
import purchaseFeedbackRequests from '../../server/purchaseFeedback';
import { addLoading, removeLoading } from './loading';

export const getPurchasesFeedbackList = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await purchaseFeedbackRequests.getPurchasesFeedbackList(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};
